'use strict';

exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// ../~/_history@3.3.0@history/lib/ExecutionEnvironment.js
// module id = 239
// module chunks = 1